import React, { useEffect, useState, useContext } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router";
import { FirebaseContext } from "../lib/firebase";

const Reset = () => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const { api, auth } = useContext(FirebaseContext);
  const [user, loading] = useAuthState(auth);
  const { sendPasswordReset } = api;
  useEffect(() => {
    if (loading) return;
    if (user) navigate.replace("/dashboard");
  }, [user, loading, navigate]);
  return (
    <div className='reset'>
      <div className='reset__container'>
        <input
          type='text'
          className='reset__textBox'
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder='E-mail Address'
        />
        <button className='reset__btn' onClick={() => sendPasswordReset(email)}>
          Send password reset email
        </button>
      </div>
    </div>
  );
};
export default Reset;
